/**
 * Centralized analytics configuration — Powtoon BITracker pattern.
 * All event categories and actions are defined here.
 */

export const ANALYTICS_CATEGORIES = {
  AUTH: "auth",
  SCENARIO: "scenario",
  SESSION: "session",
  AVATAR: "avatar",
  SCORM: "scorm",
  NAVIGATION: "navigation",
} as const;

export const ANALYTICS_ACTIONS = {
  CLICK: "click",
  LOADED: "loaded",
  ERROR: "error",
  SUCCESS: "success",
  STARTED: "started",
  COMPLETED: "completed",
  OPENED: "opened",
  CLOSED: "closed",
  NAVIGATED: "navigated",
} as const;

export type AnalyticsCategory =
  (typeof ANALYTICS_CATEGORIES)[keyof typeof ANALYTICS_CATEGORIES];
export type AnalyticsAction =
  (typeof ANALYTICS_ACTIONS)[keyof typeof ANALYTICS_ACTIONS];
